import React, { useEffect } from "react";
import TextInput from "../../../../components/Input/TextInput";
import Select from "../../../../components/Select/Select";
import { Group, SimpleGrid } from "@mantine/core";
import { useQuery } from "react-query";
import { axiosGet } from "../../../../Helpers/AxiosHelper";
import { LoaderWrapper } from "../../../../components/GeneralComponents/LoaderWrapper";

const ProtectionPlanDropdown = ({ form }) => {
  const {
    data: warrantyData,
    isLoading,
    isFetching,
    error: warrantyError,
  } = useQuery("warranties", async () => {
    const response = await axiosGet({ url: "/warranty" });
    console.log("warrantyData", response.data);
    return response.data;
  });

  useEffect(() => {
    const price = form?.values?.protectionPlanPrice ? parseFloat(form?.values?.protectionPlanPrice) : 0;
    const cost = form?.values?.protectionPlan?.cost ? parseFloat(form?.values?.protectionPlan?.cost) : 0;
    const gross = price - cost;
    console.log(gross);
    form.setFieldValue("protectionPlan.gross", gross);

    form.setFieldValue("backGross", gross);
  }, [form.values.protectionPlanPrice, form.values.protectionPlan?.cost]);

  useEffect(() => {
    const selectedWarranty = warrantyData?.data?.find((warranty) => warranty.id === form.values.protectionPlan.type);
    if (selectedWarranty) {
      form.setFieldValue("protectionPlan.cost", selectedWarranty.price);
      form.setFieldValue("protectionPlanPrice", selectedWarranty.minPrice);
      form.setFieldValue("protectionPlan.gross", selectedWarranty.price - selectedWarranty.minPrice);
      form.setFieldValue("protectionPlan.term", selectedWarranty.validationPeriodMonths);
      form.setFieldValue("protectionPlan.mileage", selectedWarranty.validationPeriodMiles);
    }
  }, [form.values.protectionPlan.type]);

  return (
    <LoaderWrapper loading={isLoading || isFetching}>
      <SimpleGrid cols={4} spacing={5}>
        <Select
          size="xs"
          label={"Type"}
          placeholder="Select VSC"
          data={
            warrantyData?.data?.map((warranty) => ({
              label: warranty.type,
              value: warranty.id,
            })) || []
          }
          form={form}
          validateName="protectionPlan.type"
        />
        <TextInput label={"Vendor"} placeholder="Vendor" form={form} validateName="protectionPlan.vendor" size="xs" />
        <TextInput label={"Price"} placeholder="Price" form={form} validateName="protectionPlanPrice" size="xs" />
        <TextInput label={"Cost"} placeholder="Cost" form={form} validateName="protectionPlan.cost" size="xs" />
        <TextInput label={"Gross"} placeholder="Gross" form={form} validateName="protectionPlan.gross" size="xs" disabled />
        <TextInput label={"Term"} placeholder="Term" form={form} validateName="protectionPlan.term" size="xs" />
        <TextInput label={"Mileage"} placeholder="Mileage" form={form} validateName="protectionPlan.mileage" size="xs" />
        <TextInput label={"Deductible"} placeholder="Deductible" form={form} validateName="protectionPlan.deductible" size="xs" />
      </SimpleGrid>
    </LoaderWrapper>
  );
};

export default ProtectionPlanDropdown;
